import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=17d2a132&scoped=true&lang=pug&"
import script from "./CustomerEdit.vue?vue&type=script&lang=coffee&"
export * from "./CustomerEdit.vue?vue&type=script&lang=coffee&"
import style0 from "./CustomerEdit.vue?vue&type=style&index=0&id=17d2a132&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2a132",
  null
  
)

export default component.exports